import React from 'react';
import './index.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NoDrugs = () => {
  return (
    <div className="noDrugsWrapper">
      <div className="noDrugsContainer">
        <LazyLoadImage
          src="/content/images/icons/noDrugs.svg"
          alt=""
          height="60px"
          width="63px"
        />
        <h3>No saved drugs</h3>
        <p className="mobile-only">
          Add to your saved drugs folder by searching <br />
          for prescriptions and tapping Save.
        </p>
        <p className="desktop-only">
          Add to your saved drugs folder by searching <br />
          for prescriptions and clicking Save.
        </p>
      </div>
    </div>
  );
};

export default NoDrugs;
